import { AuthProvider } from '@/components/auth/auth-provider'
import { SolanaProvider } from '@/components/solana/solana-provider'
import { ThemeProvider } from '@/components/theme-provider'
import { ReactQueryProvider } from '@/components/react-query-provider'
import { Toaster } from '@/components/ui/sonner'
import { WalletListener } from './auth/WalletListener'

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange
    >
      <ReactQueryProvider>
        <SolanaProvider>
          <AuthProvider>
            {children}
            <Toaster />
            <WalletListener />
          </AuthProvider>
        </SolanaProvider>
      </ReactQueryProvider>
    </ThemeProvider>
  )
}
